<div class="container" style="padding-top: 25px;">
  <mat-accordion multi>

    <mat-expansion-panel [expanded]="isFirst">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Tasking Details
        </mat-panel-title>
        <mat-panel-description>
          Enter Details and Select Options for Tasking
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="card pt-0 pr-0">
        <div class="left scrollbar" id="scrollcustom">
          <form class="form-vertical" fxLayout="column" fxLayoutGap="10px" [formGroup]="formGroup"
          *ngIf="!this.budget">
          <div class="terms" *ngIf="!this.userDetails?.allocated && hasFeature('preview')">
            <span>
              Need to see the sensor details first? Click <b (click)="openSensorPreview()">here</b>.
            </span>
          </div>
            <div class="purposes" style="margin: 0 0 20px 0;">
              <div class="loading-label-container">
                <label>Task Strategy<span>*</span></label>
              </div>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="strategyRadio" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select task strategy"
                    formControlName="strategyRadio" (selectionChange)="strategyChange($event)"
                    style="color: rgba(0, 0, 0, 0.42)" required>
                    <mat-option *ngFor="let option of strategyOptions; let i = index" [value]="option.value"
                    [disabled]="option.value === 'First Available By Platform' || ((currentUser.pointsEligible || currentUser.sub_budget_allocation) && (option.value === 'Tip-and-Cue')) || (currentUser.allocated && option.value !== 'User Initiated')
                    || (option.value === 'Tip-and-Cue' && currentUser?.user_plan === 4 && (!tipAndCueEligibilityChecked || !tipAndCueEligible))
                    || (currentUser?.cpc && option.value === 'Help Select Sensor(s)') || (currentUser?.permission_based && option.value !== 'User Initiated' && option.value !== 'Tip-and-Cue')
                    || (currentUser?.userType == subUser && currentUser.permission_based && !currentUser.permissions.includes(tipCueWorkflow)  && option.value === 'Tip-and-Cue')"
                    [matTooltip]="option.value === 'Tip-and-Cue' && currentUser?.user_plan === 4 ? 
                      (!tipAndCueEligibilityChecked ? 'Loading...' : (!tipAndCueEligible ? 'Tip-and-Cue requires both tipping and cueing capable sensors. Your current sensor allocations do not support this workflow.' : '')) : ''"
                    >
                      <span> 
                        <!-- [matTooltip]="(currentUser?.user_plan === 1 && i !== 0) ? 'This feature is available with deposit access.' : ''" -->
                        {{ option.name }} 
                      </span>
                      <span style="margin-left: 5px;"
                      [matTooltip]="option.description"
                      matTooltipClass="custom-option-tooltip"
                      >
                      <img width="17px" [src]="tooltipImagePath" style="margin-top: -2px;"/>
                      </span>
                      <img *ngIf="option.value === 'Tip-and-Cue'"
                          style="margin-left: 10px; margin-top: -1px;"
                          width="30px"
                          src="../../../assets/images/beta-version.png"
                        />
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="fields.strategyRadio.errors && fields.strategyRadio.touched">
                <div *ngIf="fields.strategyRadio.errors.required" class="error-valid">Task Strategy is required</div>
              </div>
            </div>

            <div class="purposes" style="margin: 0" *ngIf="taskStrategy === 'Tip-and-Cue'">
              <label>Sub Strategies<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                formControlName="subStrategyRadio" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select task sub strategy"
                    formControlName="subStrategyRadio" (selectionChange)="subStrategyChange($event)"
                    style="color: rgba(0, 0, 0, 0.42)">
                    <mat-option *ngFor="let option of subStrategyOptions; let i = index" [value]="option.value"
                    [disabled]="i > 0">
                      {{ option.name }} 
                      <span style="margin-left: 5px;"
                      [matTooltip]="option.description"
                      matTooltipClass="custom-option-tooltip">
                      <img width="17px" [src]="tooltipImagePath"/>
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="fields.subStrategyRadio?.errors && fields.subStrategyRadio.touched">
                <div *ngIf="fields.subStrategyRadio?.errors.required" class="error-valid">Task sub Strategy is required</div>
              </div>
            </div>


            <div class="form-lble" style="margin: 0px;">
              <label>Project Name<span>*</span></label>
              <input type="name" placeholder="Your project name" [matAutocomplete]="auto" (keyup)="nameChng($event, 1)"
                formControlName="project" required (keydown)="Space($event)" [readonly]="this.retask" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let projects of filteredProjects | async" [value]="projects?.project"
                  (click)="setProjectid(projects)">
                  <span>{{projects.project}}</span>
                </mat-option>
              </mat-autocomplete>
              <div *ngIf="fields.project.errors && fields.project.touched">
                <div *ngIf="fields.project.errors.required" class="error-valid">Project Name is required</div>
                <div *ngIf="fields.project.hasError('minlength')" class="error-valid">At least 4 characters long</div>
                <div *ngIf="fields.project.hasError('maxlength')" class="error-valid">Maximum 25 characters long</div>
              </div>
            </div>

            <div class="form-lble" style="margin: 0 0 20px 0;">
              <label>Task Name<span>*</span></label>
              <input type="name" (keyup)="nameChng($event, 2)" placeholder="Your task name" formControlName="taskname"
                required (keydown)="Space($event)" *ngIf="!this.retask" maxlength="35" />
                <input type="name" (keyup)="nameChng($event, 2)" placeholder="Your task name" formControlName="taskname"
                required (keydown)="Space($event)" *ngIf="this.retask" readonly/>

              <div *ngIf="fields.taskname.errors && fields.taskname.touched">
                <div *ngIf="fields.taskname.errors.required" class="error-valid">Task Name is required</div>
                <div *ngIf="fields.taskname.hasError('minlength')" class="error-valid">At least 5 characters long</div>
                <!-- <div *ngIf="fields.taskname.hasError('maxlength')" class="error-valid">Maximum 35 characters long</div> -->
              </div>
            </div>
          
           
            <div *ngIf="taskStrategy !== 'Outcome By Platform'" class="purposes" style="margin: 0 0 20px 0;">
              <label>Intent<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="intent" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select intent"
                    formControlName="intent" (selectionChange)="intentChange($event.value)"
                    style="color: rgba(0, 0, 0, 0.42)" required>
                    <mat-option *ngFor="let option of intentOption" [value]="option" [disabled]="currentUser.allocated && option.intent_key !== 'internalUse'">
                      {{ option.name }}

                      <span style="margin-left: 5px;" *ngIf="option?.description">
                        <img width="17px" [src]="tooltipImagePath"
                          [matTooltip]="option.description"/>
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="fields.intent.errors && fields.intent.touched">
                <div *ngIf="fields.intent.errors.required" class="error-valid">Intent is required</div>
              </div>
            </div>
            <div class="purposes" style="margin: 0 0 20px 0;">
              <label>Purpose<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="purpose" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select purpose"
                    formControlName="purpose" (selectionChange)="onPurposeChange($event.value)"
                    style="color: rgba(0, 0, 0, 0.42)" required>
                    <mat-option *ngFor="let option of purposeOption; let i = index" [value]="option" [disabled]="(taskStrategy === 'AIS Included' && option.purpose !== 'Maritime Security')">
                      {{ option.purpose }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="fields.purpose.errors && fields.purpose.touched">
                <div *ngIf="fields.purpose.errors.required" class="error-valid">Purpose is required</div>
              </div>
            </div>
            <div *ngIf="this.others">
              <label>Description<span>*</span></label>
              <input type="name" placeholder="Your description" formControlName="description" required minlength="4"
                (keydown)="Space($event)" (keyup)="descChng($event)">

              <div *ngIf="fields.description.errors && fields.description.touched">
                <div *ngIf="fields.description.errors.required" class="error-valid">Description is required</div>
                <div *ngIf="fields.description.errors?.minlength" class="error-valid">At least 4 characters long</div>
                <div *ngIf="fields.description.hasError('maxlength')" class="error-valid">Maximum 50 characters long
                </div>
              </div>
            </div>

            <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="taskStrategy=='Help Select Sensor(s)'">
              <label>Use Case/ Application<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="useCase" [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select use case"
                    formControlName="useCase" (selectionChange)="useCaseChange($event.value)"
                    style="color: rgba(0, 0, 0, 0.42)">
                    <mat-option *ngFor="let option of useCaseOption; let i = index" [value]="option" [disabled]="(taskStrategy === 'AIS Included' && i !== 10)">
                      {{ option.useCase }}
                      <span style="margin-left: 5px;" *ngIf="option.description"
                      [matTooltip]="option.description"
                      matTooltipClass="custom-option-tooltip"
                      >
                        <img width="17px" [src]="tooltipImagePath"  style="margin-top: -2px;" />
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="fields.useCase.touched">
                <div *ngIf="fields.useCase.value === null" class="error-valid">Use Case is required</div>
              </div>
            </div>
            <div *ngIf="taskStrategy=='Help Select Sensor(s)'">
              <label>Use Case Description</label>
              <input type="name" placeholder="Your description" formControlName="useCaseDescription" (keyup)="usecasedescChng($event)" [readonly]="this.retask" 
              >
              <div *ngIf="fields.useCaseDescription.errors && fields.useCaseDescription.touched">
                <div *ngIf="fields.useCaseDescription.errors?.maxlength" class="error-valid">Please enter your use case description within 50 characters
                </div>
              </div>
            </div>

            <div class="form-lble" style="margin: 0 0 20px 0;" *ngIf="taskStrategy !== 'TLE Based Tasking'">
              <div class="select-head">
                <label> Select Target*
                  <span style="padding: 0 0 0 0; display: block;">Identify your target (drop a pin, draw an area and
                    right click to complete or enter Lng, Lat coordinates)
                    on the map</span>
                </label>
              </div>
              <div class="select-details">
                <div class="map-details">
                  <input matInput type="text" placeholder="Select your desired area" formControlName="target"
                  [readonly]="true" value="{{target.geoJSON}}" style="
                      border: 1px solid #98a2b3;
                      padding: 0 0 0 11px;
                      color: #000;
                      font-weight: 500;
                      position: relative;
                    " />
                  <div class="icon">
                    <span [matTooltipClass]="'target-tooltip'" matTooltip="{{ target.geoJSON }}">
                      <img width="20px" height="20" [src]="tooltipImagePath"/>
                    </span>
                  </div>
                </div>
                <div *ngIf="fields.target.errors && fields.target.touched && !this.target?.geoJSON">
                <div *ngIf="fields.target.errors.required" class="error-valid">Target is required</div>
              </div>
              </div>
            </div>

           

            <div *ngIf="taskStrategy=='Tip-and-Cue' && subStrategy == 'Tip-and-Cue'" class="purposes" style="margin: 0 0 20px 0;">
              <div class="form-lble" style="margin: 0px;">
                <div class="row mt-2">
                  <div class="col-12"> 
                    <label>Based On<span>*</span></label>
                  </div>
                  <div class="col-12 mt-1 mb-3">
                    <mat-radio-group   aria-label="Select an option" formControlName="tipAndCueBasedOn" (change)="tipAndCueTypeChange($event)" [disabled]="this.retask">
                      <mat-radio-button checked name="tipAndCueBasedOnRadio"  value="Rules" style="margin-right:12px;">Rules</mat-radio-button>
                      <mat-radio-button name="tipAndCueBasedOnRadio" value="Feeds" style="margin-left:15px;margin-right:12px;">Feeds</mat-radio-button>
                      <mat-radio-button name="tipAndCueBasedOnRadio"  value="Observation">Observation</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div style="text-align:center;" *ngIf="taskStrategy === 'Tip-and-Cue' && tipAndCueBasedOn === 'Feeds'">
                <input type="name" *ngIf="this.retask" formControlName="feeds" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [(ngModel)]="feeds"  [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select feed"
                    formControlName="feeds"
                    style="color: rgba(0, 0, 0, 0.42);"  (selectionChange)="onFeedsChange($event.value)">
                    <mat-option *ngFor="let option of feedList" [value]="option" [selected]="feeds?.name == option.name"
                    [disabled]="!option?.enabled">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!feeds && fields.feeds.touched && taskStrategy === 'Tip-and-Cue' && tipAndCueBasedOn === 'Feeds' && !this.retask ">
                <div class="error-valid">Feed is required</div>
              </div> 
              <div style="text-align:center;" *ngIf="taskStrategy === 'Tip-and-Cue' && tipAndCueBasedOn === 'Rules' ">
                <input type="name" *ngIf="this.retask" formControlName="rule" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [(ngModel)]="rule"  [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select rule"
                    formControlName="rule" 
                    style="color: rgba(0, 0, 0, 0.42);"  >
                    <mat-option *ngFor="let option of rulesOptions" [value]="option.rule_key"
                    (click)="onRulesChange(option.rule_key)">
                      {{ option.rule_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!rule && fields.rule.touched && taskStrategy === 'Tip-and-Cue' && tipAndCueBasedOn === 'Rules' && !this.retask">
                <div  class="error-valid">Rule is required</div>
              </div>

              <div style="text-align:center;" *ngIf="taskStrategy === 'Tip-and-Cue' && tipAndCueBasedOn === 'Observation'">
                <input type="name" *ngIf="this.retask" formControlName="observation" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [(ngModel)]="observation"  [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select observation"
                    formControlName="observation"
                    style="color: rgba(0, 0, 0, 0.42);"  >
                    <mat-option *ngFor="let option of observationOptions" [value]="option" [selected]="observation?.name == option.name"
                    (click)="onObservationChange(option)"
                    >
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!observation && fields.observation.touched && taskStrategy === 'Tip-and-Cue' && tipAndCueBasedOn === 'Observation' && !this.retask ">
                <div class="error-valid">Observation is required</div>
              </div> 
            </div>

            <div style="margin: 0 0 20px 0;" *ngIf="taskStrategy !== 'TLE Based Tasking'">
              <label>Frequency<span>*</span></label>
              <input type="name" *ngIf="this.retask"
              formControlName="frequency" required [readonly]="this.retask" />
              <mat-form-field appearance="outline" class="frequ" *ngIf="!this.retask">
                <mat-select [disableOptionCentering]="true" panelClass="matopens" placeholder="Select frequency"
                  formControlName="frequency" (selectionChange)="onOptionChange($event.value)"
                  style="color: rgba(0, 0, 0, 0.42)" required>

                  <mat-option *ngFor="let option of frequencyOption; let i = index" [value]="option.name"
                  [disabled]="((taskStrategy === 'Tip-and-Cue' || taskStrategy === 'Outcome By Platform') && i === 1) || (taskStrategy === 'AIS Included' &&( i === 1 || i===0))" >

                    {{ option.name }}

                    <span [matTooltip]="getTooltip(option.name)" matTooltipClass="custom-option-tooltip">
                    <img style="margin-left: 5px;" width="17px" height="17" [src]="tooltipImagePath"/>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="fields.frequency.errors && fields.frequency.touched">
                <div *ngIf="fields.frequency.errors.required" class="error-valid">Frequency is required</div>
              </div>
            </div>

            <div *ngIf="selectedOption === 1 && clickFrequency">
              <label>Repeat</label>
              <input type="name" *ngIf="this.retask"
               [value]="this.target.freqOption" [readonly]="this.retask" />
              <mat-form-field style="width: 100%" appearance="outline" *ngIf="!this.retask">
                <mat-select [disableOptionCentering]="true" panelClass="matopens" placeholder="Choose repetition"
                  (selectionChange)="freqChange($event.value)" [value]="TASKFREQUENCY[1]">
                  <mat-option *ngFor="let option of TASKFREQUENCY; let i = index" [value]="option">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div *ngIf="selectedOption === 1 && subDaily">
              <label>Sub-daily Count</label>
              <input type="name" *ngIf="this.retask"
               [value]="this.target.subDailyCount" [readonly]="this.retask" />
              <mat-form-field style="width: 100%" appearance="outline" *ngIf="!this.retask">
                <mat-select [disableOptionCentering]="true" panelClass="matopens" placeholder="Choose sub-daily count"
                  (selectionChange)="recurrentCountChange($event.value)" [value]="dailyCount[0]">
                  <mat-option *ngFor="let option of dailyCount" [value]="option">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div *ngIf="selectedOption === 0 && clickFrequency">
              <label>Date</label>
              <mat-form-field appearance="outline">
                <mat-label>Choose date</mat-label>
                <input matInput [matDatepicker]="datepicker" [matDatepickerFilter]="DateFilter" [formControl]="date"
                  readonly [min]="todayDate" placeholder="Choose a date"
                  (dateChange)="handleDateChange($event, 1)" style="border: 0; padding: 0;" />
                <mat-datepicker-toggle matSuffix [for]="datepicker" placeholder="Choose a date"></mat-datepicker-toggle>
                <mat-datepicker #datepicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="select-daterange" *ngIf="
                ((selectedOption === 1 || selectedOption === 2) &&
                clickFrequency) || taskStrategy === 'TLE Based Tasking'
              ">
              <label>Date Range </label>
              <mat-form-field appearance="outline">
                <mat-label>Choose date range</mat-label>
                <mat-date-range-input [class.custom-date-range]="!darkTheme" placeholder="Select dates" [formGroup]="range" [rangePicker]="picker"
                  [min]="todayDate" [max]="maxDate" [comparisonStart]="range.value.start"
                  [comparisonEnd]="range.value.end" style="padding: 0" [style.pointer-events]="mapLoading ? 'none' : 'auto'">
                  <input matStartDate formControlName="start" placeholder="Start date" readonly
                    (dateChange)="handleDateChange($event, 2)" style="border: 0; height: 100%; padding: 0" />

                  <input matEndDate formControlName="end" placeholder="End date" readonly
                  [ngClass]="{ 'date-input': (selectedOption === 2 && taskStrategy != 'Tip-and-Cue') }"
                    (dateChange)="handleDateChange($event, 3)" style="border-right: 0;border-left: 0; padding: 0;" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"  [style.pointer-events]="mapLoading ? 'none' : 'auto'"
                 [style.cursor]="mapLoading ? 'not-allowed' : 'pointer'"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error *ngIf="
                    range.controls.start.hasError('matStartDateInvalid')
                  ">Invalid start date</mat-error>
                <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
              </mat-form-field>
              <span *ngIf="dateFlag" style="color: red; text-align: left; font-size: 12px;font-weight: 600;">Start date and End date
                shouldn't be same</span>
                <span *ngIf="tleRangeError" style="color: red; text-align: left; font-size: 12px;font-weight: 600;">Range should be below 72 hrs</span>
                <span *ngIf="tleStartRangeError" style="color: red; text-align: left; font-size: 12px;font-weight: 600;">Start date should be within 72 hours</span>
              <span *ngIf="range.value.end === null" style="color: red; text-align: left; font-size: 12px;font-weight: 600;">Please Select
                End date</span>
            </div>
            
            <div *ngIf="(clickFrequency && selectedOption != -1) || taskStrategy === 'TLE Based Tasking'">
              <label>Start Time (UTC)<span>*</span></label>
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  matInput
                  [ngxTimepicker]="timepicker"
                  readonly
                  style="border: none !important; height: 18px;padding-left: 1px !important;"
                  placeholder="Select start time"
                  formControlName="startTime"
                  [style.pointer-events]="mapLoading ? 'none' : 'auto'"
                />
              
                <mat-icon
                  matSuffix
                  (click)="openFromIcon(timepicker)"
                  [ngClass]="{'icon-date' : darkTheme}"
                  style="color: #7f7f7f;"
                  [style.pointer-events]="mapLoading ? 'none' : 'auto'"
                  [style.cursor]="mapLoading ? 'not-allowed' : 'pointer'"
                  matTooltip="Registered-country time to UTC converter"
                  >schedule</mat-icon
                >
                <ngx-material-timepicker #timepicker (timeSet)="onTimeSet($event)"  [defaultTime]="currentLocalTime"></ngx-material-timepicker>
              </mat-form-field>

              <div *ngIf="fields.startTime.touched">
              <div *ngIf="fields.startTime.errors && fields.startTime.errors.required" class="error-valid">Start Time is required</div>
                <div *ngIf="isPast && !fields.startTime.errors" class="error-valid">The start time needs to be ahead of the current time</div>
              </div>
            </div>

            <div *ngIf="(clickFrequency && selectedOption != -1 )|| taskStrategy === 'TLE Based Tasking'">
              <label>End Time (UTC)<span>*</span></label>
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  matInput
                  [ngxTimepicker]="pickers"
                  readonly
                  style="border: none !important; height: 18px;padding-left: 1px !important;"
                  placeholder="Select end time"
                  formControlName="endTime"
                  [style.pointer-events]="mapLoading ? 'none' : 'auto'"
                />
              
                <mat-icon
                  matSuffix
                  (click)="openDate(pickers)"
                  style="color: #7f7f7f;"
                  [style.pointer-events]="mapLoading ? 'none' : 'auto'"
                  [style.cursor]="mapLoading ? 'not-allowed' : 'pointer'"
                  [ngClass]="{'icon-date' : darkTheme}"
                  matTooltip="Registered-country time to UTC converter"
                  >schedule</mat-icon
                >
                <ngx-material-timepicker #pickers (timeSet)="onEndTimeSet($event)" [defaultTime]="currentLocalTime"></ngx-material-timepicker>
              </mat-form-field>

              <div *ngIf="fields.endTime.touched">
                <div *ngIf="fields.endTime.errors && fields.endTime.errors.required" class="error-valid">End Time is required</div>
                <div *ngIf="timeError < 4 && !isEndPast && selectedOption === 0 && !fields.endTime.errors" class="error-valid">TOI must have four hrs between the start and end times</div>
                <div *ngIf="timeError < 24 && selectedOption != 0 && !fields.endTime.errors" class="error-valid">Start and end dates/times must be at least 24 hours apart</div>
                <div *ngIf="(isEndPast && selectedOption === 0 && !fields.endTime.errors) || (isEndPast  && taskStrategy === 'TLE Based Tasking' && !fields.endTime.errors) " class="error-valid">The end time needs to be ahead of the start time</div>
                <div *ngIf="tleToiError && !fields.endTime.errors" class="error-valid">TOI must be less than or equal to 72 hrs</div>
              </div>
            </div>
            <div class="form-lble" style="margin: 0 0 20px 0;" *ngIf="taskStrategy === 'TLE Based Tasking'">
              <div class="select-head">
                <label> Select Target*
                  <span style="padding: 0 0 0 0; display: block;">Identify your target (drop a pin, draw an area and
                    right click to complete or enter Lng, Lat coordinates)
                    on the map</span>
                </label>
              </div>
              <div class="select-details">
                <div class="map-details">
                  <input matInput type="text" placeholder="Select your desired area" formControlName="target"
                  [readonly]="true" value="{{target.geoJSON}}" style="
                      border: 1px solid #98a2b3;
                      padding: 0 0 0 11px;
                      color: #000;
                      font-weight: 500;
                      position: relative;
                    " />
                  <div class="icon">
                    <span [matTooltipClass]="'target-tooltip'" matTooltip="{{ target.geoJSON }}">
                      <img width="20px" height="20" [src]="tooltipImagePath"/>
                    </span>
                  </div>
                </div>
                <div *ngIf="fields.target.errors && fields.target.touched && !this.target?.geoJSON">
                <div *ngIf="fields.target.errors.required" class="error-valid">Target is required</div>
              </div>
              </div>
            </div>
             
            <form class="form-vertical" fxLayout="column" fxLayoutGap="10px" [formGroup]="tleSensorForm">
            <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="taskStrategy === 'TLE Based Tasking'">
              <label>Sensor Type<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="sensorType" required [readonly]="this.retask" />
                 <mat-form-field appearance="outline" *ngIf="!this.retask">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select sensor type"
                      formControlName="sensorType" (selectionChange)="sensorTypeChangeTle($event.value)" style="color: rgba(0, 0, 0, 0.42)"
                      [disabled]="mapLoading"
                      >
                      <mat-option *ngFor="let option of filteredSensorTypes; let i = index" [value]="option.value"
                        [disabled]="(target.area > 0 && (option.name === 'SAR' || option.name === 'Video')) || ((target.area === 0 || !target.openWater || target.selectedOption != 2) && option.name === 'AIS')">
                        {{ option.name }}
                        <img style="margin-left: 10px;" width="17px" height="17" [src]="tooltipImagePath"
                          [matTooltip]="option.description"/>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </div>
              <div *ngIf="tleSensorFields.sensorType.errors && tleSensorFields.sensorType.touched">
                <div *ngIf="tleSensorFields.sensorType.errors.required" class="error-valid">Sensor Type is required</div>
              </div>
            </div>
             <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="taskStrategy === 'TLE Based Tasking'">
              <label>Resolution<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="resolution" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                 <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select resolution"
                      formControlName="resolution" (selectionChange)="resolutionChangeTle($event.value)" style="color: rgba(0, 0, 0, 0.42)" [disabled]="mapLoading">
                      <mat-option *ngFor="let option of this.tleSensor?.resolution; let i = index" [value]="option.key">
                          {{option?.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                
              </div>
                 <div *ngIf="tleSensorFields.resolution.errors && tleSensorFields.resolution.touched">
                <div *ngIf="tleSensorFields.resolution.errors.required" class="error-valid">Resolution is required</div>
              </div>
            </div>
            <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="taskStrategy === 'TLE Based Tasking'">
              <label>Sensor<span>*</span></label>
               <div style="text-align:center;display: flex;align-items: center; gap: 20px;">
                 <input type="name" *ngIf="this.retask"
                 formControlName="sensor" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                 <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select sensor"
                      formControlName="sensor" (selectionChange)="sensorChangeTle($event.value)" style="color: rgba(0, 0, 0, 0.42)" [disabled]="mapLoading">
                      <mat-option *ngFor="let option of this.tleSensor?.sensor; let i = index" [value]="currentUser?.obfuscated ? option.obfuscateName : option.sensorName">
                          {{currentUser?.obfuscated ? option.obfuscateName : option.sensorName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                    <span>
 <mat-icon
  class="material-icons-outlined map-active"
  [ngStyle]="{
    cursor: isTleTrackingEnabled ? 'pointer' : 'not-allowed'
  }"
  [ngClass] ="{'disabledTle': !isTleTrackingEnabled}"
  (click)="isTleTrackingEnabled && OpenSatTracking()"
  [matTooltip]="isTleTrackingEnabled ? 'Show TLE' : ''"
  [matTooltipDisabled]="!isTleTrackingEnabled"
>
  satellite_alt
</mat-icon>
          </span>
          <!-- <span>
            <mat-icon
              class="material-icons-outlined map-active"
              style="color: gray !important"
            >
              satellite_alt
            </mat-icon>
          </span> -->
              </div> 
                <div *ngIf="tleSensorFields.sensor.errors && tleSensorFields.sensor.touched">
                 <div *ngIf="tleSensorFields.sensor.errors.required" class="error-valid">Sensor is required</div>
                </div>
             </div>
             </form>
          </form>

          <form class="form-vertical" fxLayout="column" fxLayoutGap="10px" [formGroup]="budgetForm"
          *ngIf="this.budget">   
          
          
            <div class="form-lble" style="margin: 0px;">
              <div class="row mt-2">
                <div class="col-12 loading-label-container"> 
                  <label>Sensor Category<span>*</span></label>
                </div>
                <div class="col-12 mt-1 mb-3">  
                  <mat-radio-group aria-label="Select an option" formControlName="sensorCategory" (change)="categoryChange($event)" [disabled]="this.retask || this.sensorCategoryCheckLoading">
                    <span [matTooltip]="(this.budget && !sensorCategoryCheckLoading && !this.retask && !hasImagingSensors) ? 'No imaging sensors allocated.' : ''"
                          [matTooltipClass]="'custom-option-tooltip'">
                      <mat-radio-button name="sensorCategory" value="imagingSensor" style="margin-right:12px;"
                                        [disabled]="this.retask || this.sensorCategoryCheckLoading || (this.budget && !hasImagingSensors)">
                        Imaging Sensor
                      </mat-radio-button>
                    </span>
                    <span [matTooltip]="(this.budget && !sensorCategoryCheckLoading && !this.retask && !hasNonImagingSensors) ? 'No non-imaging sensors allocated.' : ''"
                          [matTooltipClass]="'custom-option-tooltip'">
                      <mat-radio-button name="sensorCategory" value="nonImagingSensor" style="margin-left:15px;margin-right:12px;"
                                        [disabled]="this.retask || this.sensorCategoryCheckLoading || (this.budget && !hasNonImagingSensors)">
                        Non Imaging Sensor
                      </mat-radio-button>
                    </span>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="form-lble" style="margin: 0 0 20px 0;">
              <div class="select-head">
                <label> Select Target*
                  <span style="padding: 0 0 0 0; display: block;">Identify your target (drop a pin, draw an area and
                    right click to complete or enter Lng, Lat coordinates)
                    on the map</span>
                </label>
              </div>
              <div class="select-details">
                <div class="map-details">
                  <input matInput type="text" placeholder="Select your desired area" formControlName="target"
                  [readonly]="true" value="{{target.geoJSON}}" style="
                      border: 1px solid #98a2b3;
                      padding: 0 0 0 11px;
                      color: #000;
                      font-weight: 500;
                      position: relative;
                    " />
                  <div class="icon">
                    <img width="20px" height="20" [src]="tooltipImagePath"
                    matTooltip="{{ target.geoJSON }}"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="purposes" style="margin: 0 0 20px 0;">
              <label>Intent<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="intent" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select intent"
                    formControlName="intent" (selectionChange)="intentChange($event.value)"
                    style="color: rgba(0, 0, 0, 0.42)" required>
                    <mat-option *ngFor="let option of intentOption" [value]="option" [disabled]="currentUser.allocated && option.intent_key !== 'internalUse'">
                      {{ option.name }}

                      <span style="margin-left: 5px;" *ngIf="option?.description">
                        <img width="17px" [src]="tooltipImagePath"
                          [matTooltip]="option.description"/>
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="budgetFields.intent.errors && budgetFields.intent.touched">
                <div *ngIf="budgetFields.intent.errors.required" class="error-valid">Intent is required</div>
              </div>
            </div>
          
            <div style="margin: 0 0 20px 0;">
              <label>Frequency<span>*</span></label>
              <input type="name" *ngIf="this.retask"
              formControlName="frequency" required [readonly]="this.retask" />
              <mat-form-field appearance="outline" class="frequ" *ngIf="!this.retask">
                <mat-select [disableOptionCentering]="true" panelClass="matopens" placeholder="Select frequency"
                  formControlName="frequency" (selectionChange)="onOptionChange($event.value)"
                  style="color: rgba(0, 0, 0, 0.42)" required>
          
                  <mat-option *ngFor="let option of frequencyOption; let i = index" [value]="option.name">
          
                    {{ option.name }}
          
                    
                    <span [matTooltip]="getTooltip(option.name)" matTooltipClass="custom-option-tooltip">
                      <img style="margin-left: 5px;" width="17px" height="17" [src]="tooltipImagePath"
                      />
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="budgetFields.frequency.errors && budgetFields.frequency.touched">
                <div *ngIf="budgetFields.frequency.errors.required" class="error-valid">Frequency is required</div>
              </div>
            </div>
          
            <div *ngIf="selectedOption === 1 && clickFrequency">
              <label>Repeat</label>
              <input type="name" *ngIf="this.retask"
               [value]="this.target.freqOption" [readonly]="this.retask" />
              <mat-form-field style="width: 100%" appearance="outline" *ngIf="!this.retask">
                <mat-select [disableOptionCentering]="true" panelClass="matopens" placeholder="Choose repetition"
                  (selectionChange)="freqChange($event.value)" [value]="TASKFREQUENCY[1]">
                  <mat-option *ngFor="let option of TASKFREQUENCY" [value]="option">
                    {{ option.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          
            <div *ngIf="selectedOption === 1 && subDaily">
              <label>Sub-daily Count</label>
              <input type="name" *ngIf="this.retask"
               [value]="this.target.subDailyCount" [readonly]="this.retask" />
              <mat-form-field style="width: 100%" appearance="outline" *ngIf="!this.retask">
                <mat-select [disableOptionCentering]="true" panelClass="matopens" placeholder="Choose sub-daily count"
                  (selectionChange)="recurrentCountChange($event.value)" [value]="dailyCount[0]">
                  <mat-option *ngFor="let option of dailyCount" [value]="option">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          
            <div *ngIf="selectedOption === 0 && clickFrequency">
              <label>Date</label>
              <mat-form-field appearance="outline">
                <mat-label>Choose date</mat-label>
                <input matInput [matDatepicker]="datepicker" [matDatepickerFilter]="DateFilter" [formControl]="date"
                  readonly [min]="todayDate" placeholder="Choose a date" value="minDate"
                  (dateChange)="handleDateChange($event, 1)" style="border: 0; padding: 0;" />
                <mat-datepicker-toggle matSuffix [for]="datepicker" placeholder="Choose a date"></mat-datepicker-toggle>
                <mat-datepicker #datepicker></mat-datepicker>
              </mat-form-field>
            </div>
          
            <div class="select-daterange" *ngIf="
                (selectedOption === 1 || selectedOption === 2) &&
                clickFrequency
              ">
              <label>Date Range </label>
              <mat-form-field appearance="outline">
                <mat-label>Choose date range</mat-label>
                <mat-date-range-input [class.custom-date-range]="!darkTheme" placeholder="Select dates" [formGroup]="range" [rangePicker]="picker"
                  [min]="todayDate" [max]="maxDate" [comparisonStart]="range.value.start"
                  [comparisonEnd]="range.value.end" style="padding: 0">
                  <input matStartDate formControlName="start" placeholder="Start date" readonly
                    (dateChange)="handleDateChange($event, 2)" style="border: 0; height: 100%; padding: 0" />
          
                  <input matEndDate formControlName="end" placeholder="End date" readonly
                  [ngClass]="{ 'date-input': (selectedOption === 2 && taskStrategy != 'Tip-and-Cue') }"
                    (dateChange)="handleDateChange($event, 3)" style="border-right: 0;border-left: 0; padding: 0;" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
          
                <mat-error *ngIf="
                    range.controls.start.hasError('matStartDateInvalid')
                  ">Invalid start date</mat-error>
                <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
              </mat-form-field>
              <span *ngIf="dateFlag" style="color: red; text-align: left; font-size: 12px;font-weight: 600;">Start date and End date
                shouldn't be same</span>
              <span *ngIf="range.value.end === null" style="color: red; text-align: left; font-size: 12px;font-weight: 600;">Please Select
                End date</span>
            </div>

            <div *ngIf="clickFrequency && selectedOption != -1">
              <label>Start Time (UTC)<span>*</span></label>
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  matInput
                  [ngxTimepicker]="timepicker"
                  readonly
                  style="border: none !important; height: 18px;padding-left: 1px !important;"
                  placeholder="Select start time"
                  formControlName="startTime"
                />
              
                <mat-icon
                  matSuffix
                  (click)="openFromIcon(timepicker)"
                  [ngClass]="{'icon-date' : darkTheme}"
                  style="color: #7f7f7f; cursor: pointer;"
                  matTooltip="Registered-country time to UTC converter"
                  >schedule</mat-icon
                >
                <ngx-material-timepicker #timepicker (timeSet)="onTimeSet($event)"></ngx-material-timepicker>
              </mat-form-field>
          
              <div *ngIf="budgetFields.startTime.touched">
              <div *ngIf="budgetFields.startTime.errors && budgetFields.startTime.errors.required" class="error-valid">Start Time is required</div>
                <div *ngIf="isPast && !budgetFields.startTime.errors" class="error-valid">The start time needs to be ahead of the current time</div>
              </div>
            </div>
          
            <div *ngIf="clickFrequency && selectedOption != -1">
              <label>End Time (UTC)<span>*</span></label>
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  matInput
                  [ngxTimepicker]="pickers"
                  readonly
                  style="border: none !important; height: 18px;padding-left: 1px !important;"
                  placeholder="Select end time"
                  formControlName="endTime"
                />
              
                <mat-icon
                  matSuffix
                  (click)="openDate(pickers)"
                  style="color: #7f7f7f; cursor: pointer;"
                  [ngClass]="{'icon-date' : darkTheme}"
                  matTooltip="Registered-country time to UTC converter"
                  >schedule</mat-icon
                >
                <ngx-material-timepicker #pickers (timeSet)="onEndTimeSet($event)" [defaultTime]="currentLocalTime" [defaultTime]="currentLocalTime"></ngx-material-timepicker>
              </mat-form-field>

              <div *ngIf="budgetFields.endTime.touched">
                <div *ngIf="budgetFields.endTime.errors && budgetFields.endTime.errors.required" class="error-valid">End Time is required</div>
                <div *ngIf="timeError < 4 && !isEndPast && selectedOption === 0 && !budgetFields.endTime.errors" class="error-valid">TOI must have four hrs between the start and end times</div>
                <div *ngIf="timeError < 24 && selectedOption != 0 && !budgetFields.endTime.errors" class="error-valid">Start and end dates/times must be at least 24 hours apart</div>
                <div *ngIf="isEndPast && selectedOption === 0 && !budgetFields.endTime.errors" class="error-valid">The end time needs to be ahead of the start time</div>
              </div>
            </div>
            <div class="purposes" style="margin: 0 0 20px 0;">
              <label class="card-label">Sensor Type<span>*</span></label>
              <div style="text-align:center;">
                <mat-form-field appearance="outline">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select sensor type"
                    formControlName="sensorType" (selectionChange)="budgetSensorChange($event)" style="color: rgba(0, 0, 0, 0.42)"
                    >
                    <mat-option *ngFor="let option of budgetSensorType; let i = index" [value]="option"
                    >
                      {{option.sensor =='RF'? capitalizeFirstLetter('RF- comms') : option.sensor =='FMV' ? capitalizeFirstLetter('Video') : capitalizeFirstLetter(option.sensor) }}
                    
                      <img style="margin-left: 10px;" width="17px" height="17" [src]="tooltipImagePath"
                      [matTooltip]="option.description"/>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="budgetFields.sensorType.errors && budgetFields.sensorType.touched">
                <div *ngIf="budgetFields.sensorType.errors.required" class="error-valid">Sensor type is required</div>
              </div>
              
            </div>
            <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="displayUpdateFrequency()"> 
                <label class="card-label">Update Frequency<span>*</span>
                  <span matTooltip="The frequency at which the AIS data is updated." matTooltipClass="custom-option-tooltip">
                    <img style="margin-left: 3px; margin-bottom: 3px;" width="15px" [src]="tooltipImagePath"
                    />
                    </span>
                </label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select frequency"
                      formControlName="updateFrequency" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of updateFrequencies; let i = index" [value]="option" (click)="updateFrequencyChange(option)">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              <div *ngIf="budgetFields.updateFrequency.errors && budgetFields.updateFrequency.touched">
                <div *ngIf="budgetFields.updateFrequency.errors.required" class="error-valid">Frequency is required</div>
              </div>
            </div>
            <div class="signalClass" style="margin: 0 0 20px 0;" *ngIf="showRfSignals()">
              <label>Signal Of Interest<span>*</span></label>
              <div style="text-align:center;">
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select
                    #signalSelect
                    formControlName="rfSignals"
                    aria-multiselectable="true"
                     [disableOptionCentering]="true"
                    panelClass="matopenpurposeRF"
                    [placeholder]="selectedDisplay?.length > 0 ? selectedDisplay : 'Select Signals'"
                    (openedChange)="updateDisplay($event)"
                    [value]="selectedDisplay"
                    [ngClass]="
                      selectedDisplay?.length > 0
                        ? 'placeholder-color-active'
                        : ''
                    "
                    [disableTriggerSelection]="true"
  (click)="$event.stopPropagation()"
   matSelectCloseOnSelectionChange="false"
                  >
                  <!-- Custom Trigger -->
                  <mat-select-trigger>
                    {{ selectedDisplay || 'Select RF Signals' }}
                  </mat-select-trigger>

                  <!-- Options -->
                    <mat-option
                      *ngFor="let option of budgetInputs?.rfSignals"
                      [value]="option"
                      class="rf-option"
                      (click)="keepOpen($event)"
                    >
                      <div class="rf-option-container">
                        <mat-checkbox
                          [checked]="selectedSignals.includes(option)"
                          (click)="$event.stopPropagation()"
                          (change)="onSignalToggle(option, $event)"
                          (click)="$event.stopPropagation()"
                        >
                          {{ option.value }}
                          <img
                            *ngIf="option?.frequency"
                            [src]="tooltipImagePath"
                            [matTooltip]="option?.frequency"
                            style="cursor: pointer; margin-left: 8px"
                            width="15px"
                          />
                        </mat-checkbox>

                        <div *ngIf="option.audioCost" class="audio-checkbox">
                          <mat-checkbox
                            [checked]="audioSelections.includes(option)"
                            [disabled]="!selectedSignals.includes(option)"
                            (click)="$event.stopPropagation()"
                            (change)="onAudioToggle(option, $event)"
                            (click)="$event.stopPropagation()"
                          >
                            Audio
                          </mat-checkbox>
                        </div>
                      </div>
                    </mat-option>

                    <!-- Close Button -->
                    <mat-option class="close-option" disabled>
                      <button
                        mat-raised-button
                        (click)="close(signalSelect, $event)"
                        [ngClass]="{'dropdown-ok-button': selectedSignals?.length > 0}"
                        style="float: right; color: #1059a9; width: 80px; border:solid 1px #0000001f;"
                      >
                        {{ selectedSignals?.length > 0 ? 'OK' : 'Close' }}
                      </button>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="budgetFields.rfSignals.errors && budgetFields.rfSignals.touched">
                <div *ngIf="budgetFields.rfSignals.errors.required" class="error-valid">Signal selection is required</div>
              </div>
              <!-- <div style="margin-top: 10px; margin-bottom: 10px" *ngIf="!isBroRF()">
                <label>Number of Collections <span>*</span></label>

                <div style="text-align:center;"> 
                  <mat-form-field appearance="outline"> 
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" 
                    placeholder="Select Collection" formControlName="rfCollection" style="color: rgba(0, 0, 0, 0.42)"> 
                      <mat-option *ngFor="let option of RFCollections" [value]="option">
                         {{ option }}
                      </mat-option> 
                    </mat-select> 
                  </mat-form-field> 
                </div>

               
                <div *ngIf="budgetFields.rfCollection.errors && budgetFields.rfCollection.touched">
                  <div *ngIf="budgetFields.rfCollection.errors.required" class="error-valid">
                    Collection is required
                  </div>
                </div>
              </div> -->
              <div *ngIf="currentUser?.raw_iq_approved === true && !isBroRF()" style="margin-top: 15px;">
                <mat-checkbox formControlName="rawIQData" class="raw-iq-checkbox">
                  <label class="raw-iq-label"> Include raw IQ data (additional cost may apply)</label>
                </mat-checkbox>
              </div>
            </div>
            <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="showResolution">
              <label>Resolution<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="resolution" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select resolution"
                    formControlName="resolution" style="color: rgba(0, 0, 0, 0.42)" required (selectionChange)="budgetResolutionChange($event)">
                    <mat-option *ngFor="let option of budgetInputs?.resolutionArr" [value]="option" (click)="sensorWarning({ value: option })">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!!(budgetFields.resolution.errors && budgetFields.resolution.touched)">
                <div *ngIf="budgetFields.resolution.errors.required" class="error-valid">Resolution is required</div>
              </div>
            </div>

            <div class="purposes" style="margin: 0 0 20px 0;">
              <label>Tasking Tier<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="taskingTier" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select tasking tier"
                    formControlName="taskingTier" style="color: rgba(0, 0, 0, 0.42)" required (selectionChange)="budgetTierChange($event)">
                    <mat-option *ngFor="let option of budgetInputs?.tierArr" [value]="option">
                      {{capitalizeFirstLetter(option.name)  }}

                      <img *ngIf="option?.tierToolTip" style="margin-left: 10px;" width="17px" height="17" [src]="tooltipImagePath"
                      [matTooltip]="option.tierToolTip"/>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!!(budgetFields.taskingTier.errors && budgetFields.taskingTier.touched)">
                <div *ngIf="budgetFields.taskingTier.errors.required" class="error-valid">Tasking tier is required</div>
              </div>
            </div>

            <div class="purposes" style="margin: 0 0 20px 0;"  *ngIf="selectedCategory != nonImagingSensor">
              <label>Cloud Cover<span>*</span></label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="cloudCover" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select cloud cover"
                    formControlName="cloudCover" style="color: rgba(0, 0, 0, 0.42)" >
                    <mat-option *ngFor="let option of budgetInputs?.cloudCoverKeys" [value]="option">
                      {{capitalizeFirstLetter(option)  }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!!(budgetFields.cloudCover.errors && budgetFields.cloudCover.touched)">
                <div *ngIf="budgetFields.cloudCover.errors.required" class="error-valid">Cloud cover is required</div>
              </div>
            </div>

            <div class="purposes" style="margin: 0 0 20px 0;" *ngIf="selectedCategory != nonImagingSensor">
              <label>Hold Back</label>
              <div style="text-align:center;">
                <input type="name" *ngIf="this.retask"
                 formControlName="holdBack" required [readonly]="this.retask" />
                <mat-form-field appearance="outline" *ngIf="!this.retask">
                  <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select hold back"
                    formControlName="holdBack" style="color: rgba(0, 0, 0, 0.42)">
                    <mat-option *ngFor="let option of budgetInputs?.holdbackArr" [value]="option">
                      {{capitalizeFirstLetter(option)  }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                
              </div>
              <div *ngIf="!!(budgetFields.holdBack?.errors && budgetFields.holdBack.touched)">
                <div *ngIf="budgetFields.holdBack.errors.required" class="error-valid">Hold back is required</div>
              </div>
            </div>
          </form>
        </div>

        <div class="right">
          <div id="wrapper">
            <div class="widget-wrap">
              <div class="tab">
                <input id="tab-1" type="checkbox" />
                <div class="content">
                  <div class="select-head">
                    <div class="preview-box">

                      <div style="font-size: 15px; color: #344054; margin-bottom: 4px;"
                      class="dark-text">
                        <span *ngIf="target.area > 0">Area: </span> <span *ngIf="target.area > 0">{{target.area}}
                          Sqkm</span>
                      </div>

                      <div id="cesiumGlobeContainerNew" class="cesiumcontainer" style="
                          width: 49%;
                          height: calc(100vh - 345px) !important;
                        ">
                         <div  *ngIf="mapLoading">
                        <ngx-spinner [fullScreen]="false"
                        type="ball-clip-rotate"
                        color="white"
                        size="medium"
                        [zIndex]="2001">
                      </ngx-spinner>
                          </div>
                        <div style="
                            position: absolute;
                            top: 40px;
                            right: 5px;
                            color: white;
                            z-index: 10;
                            height: 10px;
                          ">
                          <p>Search by Lng, Lat separated by semicolon or Location</p>
                        </div>
                        <div style="position: absolute; z-index: 1; top: 3px">
                          <div>
                            <button class="cesium-button" title="Place POI as Point"
                              (click)="drawPinOnMap(); keyIn = true" [disabled]="pinDisable || this.retask || (taskStrategy === 'TLE Based Tasking' && pointEntities.length >= 1)">
                              <img width="15px" src="../../assets/images/marker-icon.png" />
                            </button>
                          </div>
                          <div>
                            <button class="cesium-button" title="Draw AOI as rectangle" (click)="drawOnMap('rectangle')"
                              [disabled]="buttonDisable || target.buttonDisable || this.retask || taskStrategy === 'TLE Based Tasking'">
                              <img src="../../assets/images/rectangle.svg" />
                            </button>
                          </div>
                          <div>
                            <button class="cesium-button" title="Draw AOI as polygon" (click)="drawOnMap('polygon')"
                              [disabled]="buttonDisable || target.buttonDisable || this.retask || taskStrategy === 'TLE Based Tasking'">
                              <img src="../../assets/images/polygon.svg" />
                            </button>
                          </div>
                          <div>
                            <button class="cesium-button" title="Draw AOI as circle" (click)="drawOnMap('circle')"
                              [disabled]="buttonDisable || target.buttonDisable || this.retask || taskStrategy === 'TLE Based Tasking'">
                              <img src="../../assets/images/circle.svg" />
                            </button>
                          </div>
                          <div>
                            <button id="fileInput" class="cesium-button" (click)="getFileData()"
                              title="Upload kml/json file for AOI" [disabled]="buttonDisable || target.buttonDisable || this.retask || taskStrategy === 'TLE Based Tasking'">
                              <img src="assets/images/upload-file.svg" />
                            </button>
                            <input type="file" hidden id="filedatas" (change)="onFilesSelected($event)"
                              accept=".geojson,.kml,.kmz,.json" />
                          </div>
                          <div>
                            <button class="cesium-button" title="Measure distance" (click)="drawOnMap('line')"
                            [disabled]="this.retask">
                              <img src="assets/images/measurement.svg" />
                            </button>
                          </div>
                          <div>
                            <button class="cesium-button " title="Clear" (click)="resetMap(); resetBelow('target')" [disabled]="this.retask">
                              <span class='material-icons-outlined'>restart_alt</span>
                            </button>
                          </div>
                        </div>
                        <div style="
                            position: absolute;
                            z-index: 1;
                            bottom: 37px;
                            right: 0px;
                          ">
                          <div>
                            <button class="cesium-button" (click)="zoomIn()">
                              <img width="29px" src="../../assets/images/view-zoom-in.png" />
                            </button>
                          </div>
                          <div>
                            <button class="cesium-button" (click)="zoomOut()">
                              <img width="29px" src="../../assets/images/view-zoom-out.png" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="profile-btn" *ngIf="taskStrategy === 'TLE Based Tasking'" style="margin-bottom: 40px; padding-right: 15px;">
      <button class="custom-button" type="reset" (click)="resetFormTle()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!tleSubmit || outComeSubmit || tleRangeError || tleStartRangeError || tleToiError || mapLoading"
      (click)="submit()">
        Submit
      </button>
    </div>
    </mat-expansion-panel>

    <mat-expansion-panel #cloudPanel (opened)="openCloudCover()" (closed)="panelOpenState = false" *ngIf="taskStrategy !== 'TLE Based Tasking'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span>Cloud Cover Details <img style="margin-left: 3px; margin-bottom: 3px;" width="15px" [src]="tooltipImagePath"
            matTooltip="Cloud cover forecast is only available for the next 14 days." /></span>
        </mat-panel-title>
        <mat-panel-description>
          Cloud Cover for Tasking
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="tab-panels scrollbars" id="scrollcustom" *ngIf="loadTaskCostDetails() || !budgetForm?.invalid">
        <mat-slide-toggle *ngIf="weatherData.length > 0" [(ngModel)]="isChecked" (change)="getCloudData(panelOpenState,1)"
          style="margin-left: 20px">
          Hourly cloud cover
        </mat-slide-toggle>
        <div class="containers">
        <p *ngIf="weatherData.length === 0 && !this.cloudclicked" class="noData">
          Loading
        </p>
        <p *ngIf="weatherData.length === 0 && this.cloudclicked" class="noData">
          No data available
        </p>
        <div *ngFor="let weather of weatherData" class="flexs">
          <div class="cards" (click)="(isChecked && hourly) ? getHourlyCloudData(panelOpenState,weather) : ''"
          [ngClass]="{ 'cursor-style': (isChecked && hourly) }">
              <div class="climateImage" style="text-align: center;"><img src="../../../assets/weather-icons/{{weather.icon}}.png" alt="icon" style="width: auto; height: 50px"/></div>
              <div class="date">{{ weather?.date ? weather.date : weather?.datetime}}</div>
              <div class="date">{{ weather?.time }}</div>
              <div class="temperature">{{ weather.cloudcover }}%</div>
              <div class="description">{{ weather.description }}</div>
          </div>
        </div>
        </div>
      </div>

    </mat-expansion-panel>

    <mat-expansion-panel (opened)="openPanel()" (closed)="panelOpenState = false" *ngIf="taskStrategy === 'Outcome By Platform' && !retask">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span>Outcome Details</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="padding: 15px" *ngIf="loadTaskCostDetails()">
        <form class="form-vertical" fxLayout="column" [formGroup]="outComeForm">

          <div fxLayout="row" fxLayoutGap="30px" [formGroup]="outComeForm">
            <div fxLayout="column" fxLayoutGap="13px" class="card-width">
              <div class="purposes" style="margin: 0 0 20px 0;">
                <label class="card-label">Sensor Type<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select sensor type"
                      formControlName="sensorType" (selectionChange)="sensorChange($event.value)" style="color: rgba(0, 0, 0, 0.42)"
                      >
                      <mat-option *ngFor="let option of filteredSensorTypes; let i = index" [value]="option"
                        [disabled]="(target.area > 0 && (option.name === 'SAR' || option.name === 'Video')) || ((target.area === 0 || !target.openWater || target.selectedOption != 2) && option.name === 'AIS')">
                        {{ option.name }}
                        <img style="margin-left: 10px;" width="17px" height="17" [src]="tooltipImagePath"
                          [matTooltip]="option.description"/>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div style="margin: 0 0 20px 0;padding-top: 2px;">
               <label class="card-label">Intent<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose scrollCustomDiv" placeholder="Select intent"
                      formControlName="intent" (selectionChange)="outcomeIntentChange($event.value)"
                      style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of intentOption" [value]="option" [disabled]="currentUser.allocated && option.intent_key !== 'internalUse'">
                        {{ option.name }}

                        <span style="margin-left: 5px;" *ngIf="option?.description">
                          <img width="17px" [src]="tooltipImagePath"
                            [matTooltip]="option.description"/>
                        </span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="fields.intent.errors && fields.intent.touched">
                  <div *ngIf="fields.intent.errors.required" class="error-valid">Intent is required</div>
                </div>
              </div>
            </div>
      
            <div fxLayout="column" fxLayoutGap="13px" class="card-width">
              <div class="purposes" style="margin: 0 0 20px 0;" 
                *ngIf="target.taskStrategy === 'Outcome By Platform' && outComeForm.value?.sensorType?.name === 'AIS'; else enableASI">
                <label class="card-label">Update Frequency<span>*</span>
                  <span matTooltip="The frequency at which the AIS data is updated." matTooltipClass="custom-option-tooltip">
                    <img style="margin-left: 3px; margin-bottom: 3px;" width="15px" [src]="tooltipImagePath"
                    />
                    </span>
                </label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select frequency"
                      formControlName="updateFrequency" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of updateFrequencies; let i = index" [value]="option" (click)="updateFrequencyChange(option)">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <ng-template #enableASI>
                <div class="purposes" style="margin: 0 0 20px 0;">
                <label class="card-label">Resolution<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select resolution"
                      formControlName="resolution" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of this.outComesensor?.resolution; let i = index" [value]="option">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              </ng-template>
              <div style="margin: 0 0 20px 0;padding-top: 2px;">
                <label class="card-label">How Soon?<span> *</span>
                  <span matTooltip="Provide the time by when you would like to have the data from the time of interest (TOI) indicated under frequency" matTooltipClass="custom-option-tooltip">
                  <img style="margin-left: 3px; margin-bottom: 3px;" width="15px" [src]="tooltipImagePath"
                  />
                  </span>
                </label>
                <input type="name" placeholder="Hours" formControlName="latency"
                 maxlength="5" />
                  <div class="error-containers">
                    <span class="error-messages" *ngIf="outComeForm.get('latency').hasError('min')">
                      Minimum hours should be 24.
                    </span>
                    <span class="error-messages" *ngIf="outComeForm.get('latency').hasError('pattern')">
                      &nbsp;Invalid hours
                    </span>
                  </div>   
              </div> 
            </div>

            <div fxLayout="column" fxLayoutGap="13px" class="card-width">
              <div class="purposes" style="margin: 0 0 20px 0;">
                <label class="card-label">Cloud Cover<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select cloud cover"
                      formControlName="cloudCover" style="color: rgba(0, 0, 0, 0.42)"
                      [disabled]="target.taskStrategy === 'Outcome By Platform' && outComeForm.value?.sensorType?.name === 'AIS'">
                      <mat-option *ngFor="let option of this.outComesensor?.cloudCover; let i = index" [value]="option.key">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div style="margin: 0 0 20px 0;padding-top: 2px;" *ngIf="!this.currentUser?.pointsEligible">
                <label class="card-label">Budget ($)<span>*</span></label>
                <input type="name" placeholder="Your budget" formControlName="budget"
                  maxlength="12" />
                  <div class="error-containers">
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('min')">
                      Minimum budget should be $150.
                    </span>
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('pattern')">
                      &nbsp;Invalid budget
                    </span>
                  </div>   
              </div>
              <div style="margin: 0 0 20px 0;padding-top: 2px;" *ngIf="this.currentUser?.pointsEligible">
                <label class="card-label">Budget (Points)<span>*</span></label>
                <input type="name" placeholder="Your budget" formControlName="budget"
                  maxlength="12" />
                  <div class="error-containers">
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('min')">
                      Minimum budget should be {{ convertToPoints(150) }} Points.
                    </span>
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('pattern')">
                      &nbsp;Invalid budget
                    </span>
                  </div>   
              </div> 
            </div>
          </div>
      
          <div class="profile-btn">
            <button class="custom-button" type="reset" (click)="resetOutcome()">Cancel</button>
            <button mat-flat-button color="primary" [disabled]="demoView || outComeForm.invalid || outComeError
            || (this.outComesensor?.cloudCover?.length > 0 && !this.outComeForm?.value?.cloudCover) || outComeSubmit"
            (click)="submit()">
              Submit
            </button>
          </div>
      
        </form>
      </div>

    </mat-expansion-panel>

    <mat-expansion-panel #sensorPanel
     (opened)="onSensorPanelOpen()"  (closed)="panelOpenState = false" *ngIf="taskStrategy !== 'Outcome By Platform' && taskStrategy !== 'TLE Based Tasking' && !retask && !this.budget &&
     (subStrategy !== 'Tip-and-Cue-Outcome')">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Sensor-Cost Details
        </mat-panel-title>
        <mat-panel-description>
          Sensor-Costs for Available Operators
        </mat-panel-description>
      </mat-expansion-panel-header>
      <app-taskcost *ngIf="loadTaskCostDetails()"
        #sensorList
        [target]="target" (resetTasking)="resetMe($event)"
        (childEvent)="clearSatllite()" (resetData)="removeCircles()" (childDataEvent)="receiveHandler($event)"
        (resetRFData)="resetMap()" (resetSpireData)="removeRectangles()" (clearSensorCost)="handleClearSensorCost($event)"></app-taskcost>
    </mat-expansion-panel>

    <!-- Tip and cue outcome based -->
    <mat-expansion-panel 
      (opened)="panelOpenState = true" 
      (closed)="panelOpenState = false" 
      *ngIf="taskStrategy === 'Tip-and-Cue' && subStrategy == 'Tip-and-Cue-Outcome' && !retask">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span>Outcome Details</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="padding: 15px" *ngIf="loadTaskCostDetails()">
        <form class="form-vertical" fxLayout="column" [formGroup]="outComeForm">
          <div fxLayout="row" fxLayoutGap="30px" [formGroup]="outComeForm" *ngIf="taskStrategy === 'Tip-and-Cue' && subStrategy == 'Tip-and-Cue-Outcome'">
            <div fxLayout="column" fxLayoutGap="18px" class="card-width">

              <div style="margin: 0 0 20px 0;">
                <label class="card-label">Based On<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select placeholder="Select an option" panelClass="matopenpurpose"
                      [disableOptionCentering]="true" 
                      formControlName="tipAndCueBasedOn" 
                      (selectionChange)="tipAndCueTypeSelectChange($event)">
                      <mat-option value="Observation">Observation</mat-option>
                      <mat-option value="Rules">Rule</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div style="margin: 0 0 20px 0;" *ngIf="tipAndCueBasedOn === 'Observation'">
                <label class="card-label">Observation<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline" *ngIf="!this.retask">
                    <mat-select [(ngModel)]="observation"  [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select observation"
                      formControlName="observation"
                      style="color: rgba(0, 0, 0, 0.42);"  (selectionChange)="onObservationChange($event.value)">
                      <mat-option *ngFor="let option of observationOptions" [value]="option" [selected]="observation?.name == option.name"
                      [disabled]="!option?.enabled">
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div style="margin: 0 0 20px 0;" *ngIf="tipAndCueBasedOn === 'Rules'">
                <label class="card-label">Rule<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline" *ngIf="!this.retask">
                    <mat-select [(ngModel)]="rule"  [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select rule"
                      formControlName="rule" 
                      style="color: rgba(0, 0, 0, 0.42);"  (selectionChange)="onRulesChange($event.value)">
                      <mat-option *ngFor="let option of rulesOptions; let i = index" [value]="option.rule"
                      [disabled]="(target.area > 0 && i === 0)">
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div style="margin: 0 0 20px 0;padding-top: 2px;">
                <label class="card-label">How Soon?<span> *</span>
                  <span matTooltip="Provide the time by when you would like to have the data from the time of interest (TOI) indicated under frequency" matTooltipClass="custom-option-tooltip">
                  <img style="margin-left: 3px; margin-bottom: 3px;" width="15px" [src]="tooltipImagePath"
                  />
                  </span>
                </label>
                <input type="name" placeholder="Hours" formControlName="latency"
                 maxlength="5" />
                  <div class="error-containers">
                    <span class="error-messages" *ngIf="outComeForm.get('latency').hasError('min')">
                      Minimum hours should be 24
                    </span>
                    <span class="error-messages" *ngIf="outComeForm.get('latency').hasError('pattern')">
                      Invalid hours
                    </span>
                  </div>   
              </div>  


              <div style="margin: 0 0 20px 0;padding-top: 2px;" *ngIf="!this.currentUser?.pointsEligible">
                <label class="card-label">Budget ($)<span>*</span></label>
                <input type="name" placeholder="Your budget" formControlName="budget"
                  maxlength="12" />
                  <div class="error-containers">
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('min')">
                      Minimum budget should be $150
                    </span>
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('pattern')">
                      Invalid budget
                    </span>
                  </div>   
              </div>
              <div style="margin: 0 0 20px 0;padding-top: 2px;" *ngIf="this.currentUser?.pointsEligible">
                <label class="card-label">Budget (Points)<span>*</span></label>
                <input type="name" placeholder="Your budget" formControlName="budget"
                  maxlength="12" />
                  <div class="error-containers">
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('min')">
                      Minimum budget should be {{ convertToPoints(150) }} Points
                    </span>
                    <span class="error-messages" *ngIf="outComeForm.get('budget').hasError('pattern')">
                      Invalid budget
                    </span>
                  </div>   
              </div>
            </div>

            <div fxLayout="column" fxLayoutGap="13px" class="card-width">
              <div class="purposes" style="margin: 0 0 20px 0;">
                <label class="card-label">Cueing Sensor Type<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select tipping sensor type"
                      formControlName="cueingSensorType" (selectionChange)="cueingSensorChange($event.value)" style="color: rgba(0, 0, 0, 0.42)"
                      >
                      <mat-option *ngFor="let option of sensorTypesTipnCue; let i = index" [value]="option"
                      [disabled]="(target.area > 0 && (option.name === 'SAR' || option.name === 'Video')) || ((target.area === 0 || !target.openWater || target.selectedOption != 2) && option.name === 'AIS')">
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="purposes" style="margin: 0 0 20px 0; padding-top: 4px;">
                <label class="card-label">Cueing Sensor Resolution<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select resolution"
                      formControlName="cueingSensorResolution" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of cueingSensorResolution; let i = index" [value]="option">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="purposes" style="margin: 0 0 20px 0; padding-top: 4px;">
                <label class="card-label">Cueing Sensor Cloud Cover<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select cloud cover"
                      formControlName="cueingCloudCover" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of cueingSensorCloudCover; let i = index" [value]="option.key">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>    
            </div>

            <div fxLayout="column" fxLayoutGap="13px" class="card-width">
              <div class="purposes" style="margin: 0 0 20px 0;">
                <label class="card-label">Tipping Sensor Type<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select tipping sensor type"
                      formControlName="tippingSensorType" (selectionChange)="tippingSensorChange($event.value)" style="color: rgba(0, 0, 0, 0.42)"
                      >
                      <mat-option *ngFor="let option of sensorTypesTipnCue; let i = index" [value]="option"
                      [disabled]="(target.area > 0 && (option.name === 'SAR' || option.name === 'Video')) || ((target.area === 0 || !target.openWater || target.selectedOption != 2) && option.name === 'AIS')">
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="purposes" style="margin: 0 0 20px 0; padding-top: 4px;">
                <label class="card-label">Tipping Sensor Resolution<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select resolution"
                      formControlName="tippingSensorResolution" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of tippingSensorResolution; let i = index" [value]="option">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="purposes" style="margin: 0 0 20px 0; padding-top: 4px;">
                <label class="card-label">Tipping Sensor Cloud Cover<span>*</span></label>
                <div style="text-align:center;">
                  <mat-form-field appearance="outline">
                    <mat-select [disableOptionCentering]="true" panelClass="matopenpurpose" placeholder="Select cloud cover"
                      formControlName="tippingCloudCover" style="color: rgba(0, 0, 0, 0.42)">
                      <mat-option *ngFor="let option of tippingSensorCloudCover; let i = index" [value]="option.key">
                        {{ option.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
      
          <div class="profile-btn">
            <button class="custom-button" type="reset">Cancel</button>
            <button *ngIf="target.taskStrategy === 'Tip-and-Cue'" mat-flat-button color="primary" [disabled]="demoView || outComeForm.invalid
            || outComeSubmit || invalidForm || 
            (tipAndCueBasedOn === 'Observation' && !this.outComeForm?.value?.observation) || 
            (tipAndCueBasedOn === 'Rules' && !this.outComeForm?.value?.rule)"
            (click)="submit()">
              Submit
            </button>
          </div>
      
        </form>
      </div>

    </mat-expansion-panel>
    <!-- Tip and cue outcome based -->

    <div class="profile-btn" *ngIf="retask && taskStrategy !== 'TLE Based Tasking'" style="margin-bottom: 40px;">
      <button mat-flat-button color="primary" [disabled]="demoView || !loadTaskCostDetails() || outComeSubmit"
      (click)="submit()">
        Submit
      </button>
    </div>

    <div class="profile-btn" *ngIf="budget" style="margin-bottom: 40px;">
      <button class="custom-button" type="reset" (click)="resetForm(); resetCategory()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="demoView || budgetForm.invalid || this.target?.geoJSON?.length === 0 || this.target?.geoJSON === null || outComeSubmit
      || budgetEnable ()"
      (click)="submitBudget()">
        Submit
      </button>
    </div>
  </mat-accordion>
</div>
